import { CommonEnums } from '../../common.enums';
import { DxFun } from '../domain/dxfun';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { ArrayUtil } from '../utils/array.util';
import { Attribute } from '../domain/attribute';

export class DBFun {
    dxFun: DxFun;
    fldr_Id: number;
    lockBy: string;
    attributes: Array<Attribute>
    change_Ind: string;
    mode_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string
    ref_Id: number;
    ref_Cd: string;
    reusableFlag: string;
    isDependent: boolean;
    isLinkExist: boolean;
    fldrNm: string;
    imageUrl: string;
    recExists: boolean;
    dependent_Ids: Array<number>;
    selectedFlag: string;
    fldr_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.dxFun = new DxFun();
        this.attributes = new Array<Attribute>();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.unlock_Ind = CommonEnums.unlock_Ind.UNSET;;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.isDependent = false;
        this.isLinkExist = false;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.recExists = false;
        this.dependent_Ids = new Array<number>();
        this.selectedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: any): DBFun {
        let dBFun: DBFun = new DBFun();
        dBFun.copyFrom(object as DBFun);
        return dBFun;
    }

    copy(): DBFun {
        let dBFunTmp: DBFun = new DBFun();

        dBFunTmp.dxFun = this.dxFun.copy();
        dBFunTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);
        dBFunTmp.change_Ind = this.change_Ind
        dBFunTmp.mode_Ind = this.mode_Ind
        dBFunTmp.unlock_Ind = this.unlock_Ind;
        dBFunTmp.error_Cd = this.error_Cd;
        dBFunTmp.error_Msg = this.error_Msg;
        dBFunTmp.ref_Id = this.ref_Id;
        dBFunTmp.ref_Cd = this.ref_Cd
        dBFunTmp.fldr_Id = this.fldr_Id;
        dBFunTmp.lockBy = this.lockBy;
        dBFunTmp.reusableFlag = this.reusableFlag;
        dBFunTmp.isDependent = this.isDependent;
        dBFunTmp.isLinkExist = this.isLinkExist;
        dBFunTmp.fldrNm = this.fldrNm;
        dBFunTmp.imageUrl = this.imageUrl;
        dBFunTmp.recExists = this.recExists;
        dBFunTmp.dependent_Ids = ArrayUtil.getInstance().copy(this.dependent_Ids);
        dBFunTmp.selectedFlag = this.selectedFlag;
        dBFunTmp.fldr_Cd = this.fldr_Cd;

        return dBFunTmp;
    }

    copyFrom(dBFunTmp: DBFun): void {
        this.dxFun.copyFrom(dBFunTmp.dxFun);
        AttributesUtil.getInstance().copyFrom(this.attributes, dBFunTmp.attributes);
        this.change_Ind = dBFunTmp.change_Ind;
        this.mode_Ind = dBFunTmp.mode_Ind;
        this.unlock_Ind = dBFunTmp.unlock_Ind;
        this.error_Cd = dBFunTmp.error_Cd;
        this.error_Msg = dBFunTmp.error_Msg;
        this.ref_Id = dBFunTmp.ref_Id;
        this.fldr_Id = dBFunTmp.fldr_Id;
        this.lockBy = dBFunTmp.lockBy;
        this.ref_Cd = dBFunTmp.ref_Cd;
        this.reusableFlag = dBFunTmp.reusableFlag;
        this.isDependent = dBFunTmp.isDependent;
        this.isLinkExist = dBFunTmp.isLinkExist;
        this.fldrNm = dBFunTmp.fldrNm;
        this.imageUrl = dBFunTmp.imageUrl;
        this.recExists = dBFunTmp.recExists;
        ArrayUtil.getInstance().copyFrom(this.dependent_Ids, dBFunTmp.dependent_Ids);
        this.selectedFlag = dBFunTmp.selectedFlag;
        this.fldr_Cd = dBFunTmp.fldr_Cd;
    }

    compare(dBFunTmp: DBFun): string {
        let diffString: string = this.dxFun.compare(dBFunTmp.dxFun);
        if (diffString != '') return diffString;

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DBfun [ 'dxFun: '" + this.dxFun.toString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", change_Ind=" + this.change_Ind +
            ", mode_Ind=" + this.mode_Ind +
            ", unlock_Ind=" + this.unlock_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", fldr_Id =" + this.fldr_Id +
            ", lockBy = " + this.lockBy +
            ", ref_Cd=" + this.ref_Cd +
            ", reusableFlag=" + this.reusableFlag +
            ", isDependent=" + this.isDependent +
            ", isLinkExist" + this.isLinkExist +
            ", fldrNm" + this.fldrNm +
            ", imageUrl" + this.imageUrl +
            ", isRecExists+" + this.recExists +
            ", dependent_Ids" + ArrayUtil.getInstance().toString(this.dependent_Ids) +
            ", selectedFlag" + this.selectedFlag +
            ", fldr_Cd" + this.fldr_Cd + "]";

        return str;
    }
}